import {store} from "@/store/store-decorators";
import {RootStore} from "@/store/RootStore";
import ProductionOrder from "@/domain/production/ProductionOrder";
import {reactive} from "vue";
import SalesOrder from "@/domain/production/SalesOrder";
import ProposalSimpleDTO from "@/dto/ProposalSimpleDTO";
import ProductionOrderAssembly from "@/domain/production/ProductionOrderAssembly";
import AssemblyCycle from "@/domain/production/AssemblyCycle";

type State = {
    salesOrders: Array<SalesOrder>;
    productionOrders: Array<ProductionOrder>;
    productionOrderAssemblies: Array<ProductionOrderAssembly>;
    proposalDTOs: Array<ProposalSimpleDTO>;
    assemblyCycles: Array<AssemblyCycle>;
    selectedOperators: Array<number>;
}

@store
export default class ProductionStore {
    private rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    private state = reactive<State>({
        salesOrders: [],
        productionOrders: [],
        productionOrderAssemblies: [],
        proposalDTOs: [],
        assemblyCycles : [],
        selectedOperators: []
    })

    get salesOrders(): Array<SalesOrder> {
        return this.state.salesOrders;
    }

    set salesOrders(value: Array<SalesOrder>) {
        this.state.salesOrders = value;
    }

    get productionOrders(): Array<ProductionOrder> {
        return this.state.productionOrders;
    }

    set productionOrders(value: Array<ProductionOrder>) {
        this.state.productionOrders = value;
    }

    get productionOrderAssemblies(): Array<ProductionOrderAssembly> {
        return this.state.productionOrderAssemblies;
    }

    set productionOrderAssemblies(value: Array<ProductionOrderAssembly>) {
        this.state.productionOrderAssemblies = value;
    }

    get proposalDTOs(): Array<ProposalSimpleDTO> {
        return this.state.proposalDTOs;
    }

    set proposalDTOs(value: Array<ProposalSimpleDTO>) {
        this.state.proposalDTOs = value;
    }

    get assemblyCycles(): Array<AssemblyCycle> {
        return this.state.assemblyCycles;
    }

    set assemblyCycles(value: Array<AssemblyCycle>) {
        this.state.assemblyCycles = value;
    }

    get selectedOperators(): Array<number> {
        return this.state.selectedOperators;
    }

    set selectedOperators(val: Array<number>) {
        this.state.selectedOperators = val;
    }
}